import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Tooltip from '../../../../../../../../../../../../components/Tooltip'
import TooltipTrigger from '../../../../../../../../../../../../components/Tooltip/TooltipTrigger'
import TooltipContent from '../../../../../../../../../../../../components/Tooltip/TooltipContent'
import AllRowsSelectionCell from '../../../../../../../../../../../../components/Table/ReusableCells/AllRowsSelectionCell'

import { AddProductsBulkContext } from '../../../../../AddProductsBulkContext'
import useStyles from './styles'

const PeriodsValidationCell = ({ validProductsIds }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  const { isAllProductsLoaded } = useContext(AddProductsBulkContext)

  // disabled when there are no valid products or when all products are not loaded yet
  const isDisabled = !validProductsIds?.length || !isAllProductsLoaded

  return isDisabled ? (
    <Tooltip className={classes.tooltip} placement="top-start">
      <TooltipTrigger className={classes.tooltipTrigger}>
        <AllRowsSelectionCell Context={AddProductsBulkContext} isDisabled={isDisabled} />
      </TooltipTrigger>
      <TooltipContent>
        <div className={classes.noPeriods}>
          {isAllProductsLoaded
            ? t(
                'The select all option is disabled there is no product with available inventory for the selected period'
              )
            : t('The select all option is disabled until all media products for the selected filters are loaded.')}
        </div>
      </TooltipContent>
    </Tooltip>
  ) : (
    <AllRowsSelectionCell Context={AddProductsBulkContext} />
  )
}

PeriodsValidationCell.propTypes = {
  validProductsIds: PropTypes.array.isRequired
}

export default PeriodsValidationCell
